/**
 * Texto del enlace de recordatorio que acompaña al CTA en el estado
 * «Disponible el …». Vive aquí, junto a `buildGoogleCalendarUrl` (que construye
 * la URL que ese enlace abre), porque lo pintan DOS secciones de la ficha:
 * `PerformanceHero` y `PerformanceBuyBox`. Ambas deben rotular y comportarse
 * igual — si mañana el enlace deja de ir a Google Calendar y abre un selector,
 * el cambio tiene un solo sitio donde hacerse.
 */
export const CALENDAR_LINK_LABEL = 'Añadir al calendario'

/** `nicename` de `extras[]` que alimentan filas de la tabla de highlights de la ficha. */
export const EXTRA_SHOW_LENGTH = 'show_length'
export const EXTRA_GATES = 'gates'
export const EXTRA_HANDICAPPED = 'handicapped'
export const EXTRA_AGES = 'ages'
